import { render, staticRenderFns } from "./lookApply.vue?vue&type=template&id=f3f69b54&scoped=true"
import script from "./lookApply.vue?vue&type=script&lang=js"
export * from "./lookApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f69b54",
  null
  
)

export default component.exports